import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconRatingStarBold';
/** Renders an SVG icon. */
const SvgRatingStarBold = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M13.923 3.787c.768-1.848 3.386-1.848 4.155 0l2.738 6.584 7.109.57c1.995.16 2.804 2.65 1.284 3.952l-5.416 4.639 1.654 6.936c.465 1.947-1.653 3.486-3.361 2.443L16 25.193l-6.086 3.718c-1.707 1.043-3.825-.496-3.36-2.443l1.654-6.936-5.416-4.64c-1.52-1.301-.711-3.791 1.284-3.951l7.108-.57zM16 9.207l-1.533 3.687a2.25 2.25 0 0 1-1.898 1.379l-3.98.319 3.033 2.597c.64.55.92 1.41.725 2.231l-.927 3.884 3.407-2.081a2.25 2.25 0 0 1 2.346 0l3.407 2.08-.926-3.883a2.25 2.25 0 0 1 .725-2.23l3.032-2.598-3.98-.32a2.25 2.25 0 0 1-1.898-1.378z"
      />
    </svg>
  );
};
SvgRatingStarBold.displayName = displayName;
export default SvgRatingStarBold;
